export default __webpack_public_path__ + "static/media/Staff5.8ac46e6f.png";